import { apiClient } from './client';
import type { TokenResponse } from '@/types/auth.types';

export interface AuthLoginParams {
  username: string;
  password: string;
  tenant_code: string;
}

export interface AuthenticationMethods {
  authentication_mode: string;
  sso_enabled: boolean;
  local_login_mode: string;
}

export const authApi = {
  login: async (params: AuthLoginParams): Promise<TokenResponse> => {
    const response = await apiClient.post<TokenResponse>('/auth/login', params);
    return response.data;
  },

  logout: async (refreshToken?: string | null): Promise<void> => {
    await apiClient.post('/auth/logout', {
      refresh_token: refreshToken || undefined,
    });
  },

  getMethods: async (tenantCode: string): Promise<AuthenticationMethods> => {
    const response = await apiClient.get<AuthenticationMethods>('/auth/methods', {
      params: { tenant_code: tenantCode },
    });
    return response.data;
  },
};
